import React, { useEffect, useState } from "react";
import axios from "axios";

/* ================= API CONFIG (FIXED) ================= */
const API = axios.create({
  baseURL: "https://backend.sacmtb.com/api", // ✅ FORCE LIVE API
  timeout: 10000,
});

/* ================= INTERCEPTOR ================= */
API.interceptors.request.use((config) => {
  try {
    const adminData = JSON.parse(localStorage.getItem("admin") || "{}");
    const userData = JSON.parse(localStorage.getItem("user") || "{}");

    const token =
      adminData?.token ||
      userData?.token ||
      localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    console.log("👉 API CALL:", config.baseURL + config.url);
    console.log("👉 TOKEN:", token);
  } catch (err) {
    console.warn("Token error:", err);
  }

  return config;
});

/* ================= COMPONENT ================= */
function Orders() {
  const [orders, setOrders] = useState([]);
  const [tab, setTab] = useState("waiting");
  const [isAdmin, setIsAdmin] = useState(false);
  const [shipmentDetails, setShipmentDetails] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ================= FETCH ORDERS ================= */
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        setLoading(true);

        const adminData = JSON.parse(localStorage.getItem("admin") || "{}");
        const userData = JSON.parse(localStorage.getItem("user") || "{}");

        let role = "user";

        if (adminData?.token) role = "admin";
        else if (!userData?.token) {
          setError("Please login first");
          return;
        }

        setIsAdmin(role === "admin");

        const url = role === "admin" ? "/orders" : "/orders/myorders";

        const res = await API.get(url);

        console.log("📦 RESPONSE:", res.data);

        // ✅ FIXED DATA HANDLING
        setOrders(res.data.orders || []);
      } catch (err) {
        console.error("❌ FETCH ERROR:", err);

        if (err.response) {
          setError(err.response.data?.message || "Server error");
        } else if (err.request) {
          setError("Backend not reachable");
        } else {
          setError("Something went wrong");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  /* ================= SAFE FILTER ================= */
  const filteredOrders = Array.isArray(orders)
    ? orders.filter((o) => o.status === tab)
    : [];

  /* ================= SHIPMENT ================= */
  const handleShipmentChange = (id, field, value) => {
    setShipmentDetails((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
  };

  const submitShipment = async (id) => {
    const { deliveryPartner, trackingId } = shipmentDetails[id] || {};

    if (!deliveryPartner || !trackingId) {
      return alert("Fill all shipment fields");
    }

    try {
      const res = await API.put(`/orders/${id}/status`, {
        status: "shipping",
        deliveryPartner,
        trackingId,
      });

      setOrders((prev) =>
        prev.map((o) => (o._id === id ? { ...o, ...res.data.order } : o))
      );

      alert("Shipment updated");
    } catch (err) {
      console.error(err);
      alert("Failed to update shipment");
    }
  };

  /* ================= STATUS ================= */
  const updateStatus = async (id, status) => {
    if (!isAdmin) return alert("Admin only");

    try {
      const res = await API.put(`/orders/${id}/status`, { status });

      setOrders((prev) =>
        prev.map((o) => (o._id === id ? { ...o, ...res.data.order } : o))
      );

      alert(`Order marked as ${status}`);
    } catch (err) {
      console.error(err);
      alert("Failed to update status");
    }
  };

  const cancelOrder = async (id) => {
    const reason = prompt("Enter reason");
    if (!reason) return;

    try {
      const res = await API.put(`/orders/${id}/status`, {
        status: "cancelled",
        cancellationReason: reason,
      });

      setOrders((prev) =>
        prev.map((o) => (o._id === id ? { ...o, ...res.data.order } : o))
      );

      alert("Order cancelled");
    } catch (err) {
      console.error(err);
      alert("Failed to cancel order");
    }
  };

  /* ================= UI STATES ================= */
  if (loading) return <h3 style={{ padding: "20px" }}>Loading orders...</h3>;

  if (error) return <h3 style={{ padding: "20px" }}>{error}</h3>;

  /* ================= UI ================= */
  return (
    <div style={{ padding: "20px" }}>
      <h2>{isAdmin ? "Admin Orders" : "My Orders"}</h2>

      {/* Tabs */}
      <div style={{ marginBottom: "20px" }}>
        {["waiting", "shipping", "completed", "cancelled"].map((t) => (
          <button
            key={t}
            onClick={() => setTab(t)}
            style={{
              marginRight: "10px",
              background: tab === t ? "#ff7a18" : "#ddd",
              color: tab === t ? "#fff" : "#000",
              padding: "8px 12px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            {t}
          </button>
        ))}
      </div>

      {filteredOrders.length === 0 && <p>No orders found.</p>}

      {filteredOrders.map((o) => (
        <div
          key={o._id}
          style={{
            border: "1px solid #ccc",
            margin: "10px 0",
            padding: "15px",
            borderRadius: "8px",
          }}
        >
          <h4>Order ID: {o._id}</h4>
          <p><strong>User:</strong> {o.user?.name}</p>
          <p><strong>Status:</strong> {o.status}</p>
          <p><strong>Total:</strong> ₹{o.totalPrice}</p>

          {isAdmin && o.status === "waiting" && (
            <>
              <input
                placeholder="Delivery Partner"
                onChange={(e) =>
                  handleShipmentChange(o._id, "deliveryPartner", e.target.value)
                }
              />
              <input
                placeholder="Tracking ID"
                onChange={(e) =>
                  handleShipmentChange(o._id, "trackingId", e.target.value)
                }
              />
              <button onClick={() => submitShipment(o._id)}>
                Submit Shipment
              </button>
            </>
          )}

          {isAdmin && (
            <>
              <button onClick={() => updateStatus(o._id, "completed")}>
                Complete
              </button>
              <button onClick={() => cancelOrder(o._id)}>Cancel</button>
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default Orders;